import { useCallback, useState } from 'react';

const KEY = 'gita-bookmarks';

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function write(bookmarks) {
  try {
    localStorage.setItem(KEY, JSON.stringify(bookmarks));
  } catch {}
}

export function useBookmarks() {
  const [bookmarks, setBookmarks] = useState(read);

  const isBookmarked = useCallback((id) => bookmarks.some((b) => b.id === id), [bookmarks]);

  const toggleBookmark = useCallback((entry) => {
    setBookmarks((prev) => {
      const exists = prev.some((b) => b.id === entry.id);
      const next = exists ? prev.filter((b) => b.id !== entry.id) : [entry, ...prev];
      write(next);
      return next;
    });
  }, []);

  return { bookmarks, isBookmarked, toggleBookmark };
}
